var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M187.309,167.857c-15.91,9.45-37.887,15.297-62.154,15.297c-21.45,0-41.104-4.563-56.366-12.155"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M169.718,69.351c-11.517-8.963-25.947-14.355-41.667-14.355c-15.721,0-30.155,5.392-41.669,14.355"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: " 128.051,79.514 139.801,104.608 167.303,108.034 147.064,126.965 152.31,154.179 128.051,140.779 103.787,154.179 109.036,126.965 88.794,108.034 115.746,104.425  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M201.448,103.761c-12.806-24.019,10.253-51.78,10.253-51.78l-32.906-33.444C152.904,43.353,128,18,128,18 s-24.906,25.353-50.796,0.537L44.298,51.981c0,0,23.058,27.761,10.253,51.78c-3.726,6.991-53.538,86.017,37.754,111.111 C111.318,220.099,120.61,223.506,128,238c7.396-14.494,16.681-17.901,35.694-23.128 C254.986,189.778,205.178,110.752,201.448,103.761z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.1629d94243d963534b04829bb4c6b0a8.svg";
export { ForwardRef as ReactComponent };